import { CINEMATIC_DEFAULTS } from '@shared/core/website/headerMotion/headerMotion.catalog';
import type { HeaderMotionOptions } from '@shared/core/website/headerMotion/headerMotion.types';

/**
 * Sanitises saved cinematic options. Never throws on bad input: each field falls back to its
 * default, and unknown keys are dropped, so a hand-edited or stale blob still renders instead of
 * breaking the header. Hand-written rather than zod so the guest bundle does not pull zod in.
 */
export const parseCinematicOptions = (raw: Readonly<Record<string, unknown>>): HeaderMotionOptions => ({
  filmTexture: typeof raw.filmTexture === 'boolean' ? raw.filmTexture : CINEMATIC_DEFAULTS.filmTexture,
  play: 'first-visit',
});
